import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "title": "I ❤️ WATSONx",
          "theme_classic": "Classic",
          "theme_amour": "Amour",
          "theme_sweetheart": "Sweetheart",
          "about_us": "About us",
          "get_valentine_card": "Get your perfect Valentine’s card",
          "phrase1": "When your friend's love language is words and all you've got is, 'You're awesome.'",
          "phrase2": "It's all fun and games until you're addressing envelopes at 1 a.m.",
          "phrase3": "Because when she said ‘surprise me,’ she didn’t mean with a blank card.",
          "phrase4": "Teachers: making every kid feel special one painstakingly handwritten card at a time.",
          "assistant_intro": "I'm your IBM AI assistant—let’s craft the perfect message or gift this Valentine’s Day!",
          "who_is_this_for": "Who is this for?",
          "created_by": "Created by",
          "and": "and",
          "terms": "Terms",
          "privacy": "Privacy",
          "contact": "Contact",
          "recipient_partner": "Partner",
          "recipient_sibling": "Sibling",
          "recipient_special_friend": "Special friend",
          "recipient_best_friend": "Best friend",
          "recipient_child": "Child",
          "recipient_crush": "Crush",
          "recipient_mother": "Mother",
          "recipient_father": "Father",
          "recipient_grandparent": "Grandparent",
          "recipient_other": "Other",
          "theme_amour_desc": "Passionate & romantic",
          "theme_classic_desc": "Elegant & timeless",
          "theme_sweetheart_desc": "Sweet & playful",
          "back_home": "Back"
        },
      },
      es: {
        translation: {
          "title": "I ❤️ WATSONx",
          "theme_classic": "Clásico",
          "theme_amour": "Amor",
          "theme_sweetheart": "Encanto",
          "about_us": "Sobre nosotros",
          "get_valentine_card": "Consigue tu tarjeta perfecta para San Valentín",
          "phrase1": "Cuando el lenguaje del amor de tu amigo son las palabras y lo único que tienes es, 'Eres increíble.'",
          "phrase2": "Todo es diversión y juegos hasta que estás envolviendo sobres a la 1 a.m.",
          "phrase3": "Porque cuando ella dijo 'sorpréndeme', no se refería a una tarjeta en blanco.",
          "phrase4": "Maestros: haciendo que cada niño se sienta especial con una tarjeta escrita a mano a la vez.",
          "assistant_intro": "Soy tu asistente con IA de IBM—¡vamos a crear el mensaje o regalo perfecto para este Día de San Valentín!",
          "who_is_this_for": "¿Para quién es esto?",
          "created_by": "Creado por",
          "and": "e",
          "terms": "Términos",
          "privacy": "Privacidad",
          "contact": "Contacto",
          "recipient_partner": "Pareja",
          "recipient_sibling": "Hermano/a",
          "recipient_special_friend": "Amigo/a especial",
          "recipient_best_friend": "Mejor amigo/a",
          "recipient_child": "Niño/a",
          "recipient_crush": "Enamorad@",
          "recipient_mother": "Madre",
          "recipient_father": "Padre",
          "recipient_grandparent": "Abuelo/a",
          "recipient_other": "Otro",
          "theme_amour_desc": "Apasionado y romántico",
          "theme_classic_desc": "Elegante y atemporal",
          "theme_sweetheart_desc": "Dulce y juguetón",
          "back_home": "Volver"
        },
      },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;